var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SingleTextEntry',{attrs:{"act_id":"act_18","scene_id":5,"intro_text":"Tras este proceso y  evolución...","title":"Diagnóstico del paciente","question":"¿Cuál fue el diagnóstico?","feedback":_vm.feedback_content,"incorrect_msg":"La respuesta es incorrecta","option":[
        {
            id:0,
            solution: 'SCACEST',
            value: '',
        }
    ],"clue_text":"Ahora recuerda y ordena las letras que has ido anotando","final_activity":true}})}
var staticRenderFns = []

export { render, staticRenderFns }